<template>
  <div
    v-loading="loading"
    class="copyPopup"
  >
    <div class="copyPopup_titleArea">
      <h3 class="title">复制落地页</h3>
      <i
        class="icon"
        @click="$emit('close')"
      >X</i>
    </div>
    <div class="copyPopupMain">
      <div class="copyPopup_tipsArea">
        <span class="tips">复制落地页后将会产生一条新的落地页，请为新的落地页命名</span>
      </div>
      <div class="copyPopup_inputArea">
        <el-input
          v-model="valueName"
          placeholder="请输入内容"
        />
      </div>
    </div>

    <div class="copyPopup_buttonArea">
      <el-button>取消</el-button>
      <el-button
        type="primary"
        @click="determine"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { copyLandingPage } from '@/api/landingPage.js'
export default {
  props: {
    activeItem: {}
  },
  data() {
    return {
      valueName: '',
      loading: false
    }
  },
  created() {
    this.valueName = this.activeItem.novel_name + '--复制'
  },

  methods: {
    async determine() {
      this.loading = true
      await copyLandingPage({
        account_id: this.activeItem.account_id,
        page_id: this.activeItem.page_id,
        name: this.valueName
      })
      this.$message({
        message: '提交成功',
        type: 'success'
      })
      this.loading = false

      this.$emit('close', 'copyItem')
    }
  }
}
</script>

<style scoped lang="less">
.copyPopup {
  width: 500px;
  height: 300px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  .copyPopup_titleArea {
    display: flex;
    padding: 13px;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    .title {
      font-weight: bold;
    }
    .icon {
      font-style: normal;
      cursor: pointer;

      &:hover {
        font-weight: bold;
      }
    }
  }

  .copyPopupMain {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 26px;
    .copyPopup_tipsArea {
      .tips {
        color: #909090;
      }
    }

    .copyPopup_inputArea {
      margin-top: 10px;
    }
  }

  .copyPopup_buttonArea {
    padding: 10px;
    display: flex;
    justify-content: end;
    border-top: 1px solid #ccc;
  }
}
</style>
